define('presentation/settings/callQueues/presentationObjects/callQueuePresentationObject',[],function() {
    return function(){
        const self = this;

        self.accountCallQueueId = null;
        self.name = null;
        self.iconName = 'callQueue';
        self.poolCount = 0;
        self.maxCallersInQueue = 0;
        self.createdDateTime = null;
        self.modifiedDateTime = null;
        self.editCallQueueUrl = null;
    };
});

